<template>
  <div class="q-gutter-y-md structure-search-form">
    <q-card
      style="
        max-width: 540px;
        margin-right: 0;
        margin-left: auto;
        border: 1px solid var(--q-whiteBorder);
        box-shadow: none;
      "
    >
      <q-btn-toggle
        v-model="editorFlgComputed"
        flat
        dense
        text-color="grey-7"
        toggle-color="primary"
        no-caps
        :options="[
          { label: '構造式', value: true },
          { label: 'SDFile', value: false },
        ]"
        class="page-toggle"
        style="width: 100%"
      />
      <div v-show="editorFlgComputed" style="padding: 10px 10px 4px">
        <iframe
          id="sketch-iframe"
          ref="sketch-iframe"
          data-toolbars="reporting"
          title="marvin js editor"
          src="../sketch/editorws.html"
          style="overflow: hidden; width:100%; height: 100% min-width: 500px; min-height: 350px; border: 1px solid darkgray"
        ></iframe>
      </div>
      <div v-show="!editorFlgComputed" style="padding: 10px">
        <q-file
          v-model="sdfFileComputed"
          outlined
          clearable
          accept=".sdf"
          @clear="sdfFileComputed = undefined"
        >
          <template #prepend>
            <q-icon name="attach_file" />
          </template>
        </q-file>
      </div>
    </q-card>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  // Marvin Editor表示
  editorFlg: boolean;
  // SDFファイル
  sdfFile: File | undefined;
}

const props = defineProps<Props>();

const emit = defineEmits(['changeEditorFlg', 'changeSdfFile']);

// Marvin Editor表示
const editorFlgComputed = computed({
  get: () => props.editorFlg,
  set: (value) => {
    emit('changeEditorFlg', value);
  },
});

// SDFファイル
const sdfFileComputed = computed({
  get: () => props.sdfFile,
  set: (value) => {
    emit('changeSdfFile', value);
  },
});
</script>
<style>
.structure-search-form .page-toggle button {
  font-size: 1.1rem;
  width: 50%;
  height: 40px;
  padding: 0;
  padding-top: 4px;
}

.structure-search-form .page-toggle.q-btn-group.q-btn-toggle button:first-child {
  border-right: 1px solid var(--q-whiteBorder);
  letter-spacing: 5px;
}

.structure-search-form .page-toggle button {
  border-bottom: 1px solid var(--q-whiteBorder);
}

.structure-search-form .page-toggle button.text-primary {
  border-bottom-color: transparent;
}
</style>
